// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Popover_tooltip__3mvdt"};